export const url="https://scared-felidae-manageedu-191c5e52.koyeb.app";
export const localUrl="http://localhost:8000";